import React, { useEffect, useState } from "react";
import { Button, Form, Input, Switch, message } from "antd";
import { useTranslation } from "react-i18next";
import { fetchSalesHandoffRules, saveSalesHandoffRule } from "../salesHandoffService";
import styles from "./intentInsights.module.scss";

export default function SalesHandoffRulesPanel({ botId }) {
  const { t } = useTranslation();
  const [rules, setRules] = useState([]);
  const [simulated, setSimulated] = useState(true);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (!botId) return;
    fetchSalesHandoffRules(botId)
      .then((res) => {
        setRules(res.rules || []);
        setSimulated(Boolean(res.simulated));
      })
      .catch(() => {
        setRules([]);
      });
  }, [botId]);

  const handleCreate = async (values) => {
    setLoading(true);
    try {
      const res = await saveSalesHandoffRule(botId, {
        name: values.name,
        conditions: [
          { field: "intent", operator: "equals", value: values.intent },
          { field: "lead_captured", operator: "equals", value: values.leadCaptured ? "yes" : "no" },
        ],
        action: "send_to_sales",
        destination: values.destination || "sales_team",
        enabled: values.enabled !== false,
      });
      setRules((prev) => [...prev.filter((r) => r.id !== res.rule?.id), res.rule]);
      message.success(t("sonic_prospect.sales_handoff.rule_saved"));
      form.resetFields();
    } catch (_) {
      message.error(t("sonic_prospect.sales_handoff.rule_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <aside className={styles.handoffRulesPanel}>
      <h3>{t("sonic_prospect.sales_handoff.automation_title")}</h3>
      <p className={styles.handoffRulesLead}>{t("sonic_prospect.sales_handoff.automation_lead")}</p>
      {simulated ? (
        <p className={styles.handoffRulesSim}>{t("sonic_prospect.sales_handoff.automation_simulated")}</p>
      ) : null}
      {rules.length ? (
        <ul className={styles.handoffRulesList}>
          {rules.map((rule) => (
            <li key={rule.id}>
              <strong>{rule.name}</strong>
              <span>{rule.destination}</span>
            </li>
          ))}
        </ul>
      ) : null}
      <Form form={form} layout="vertical" onFinish={handleCreate}>
        <Form.Item name="name" label={t("sonic_prospect.sales_handoff.rule_name")} initialValue="Pricing high-intent handoff">
          <Input />
        </Form.Item>
        <Form.Item name="intent" label={t("sonic_prospect.sales_handoff.rule_intent")} initialValue="Pricing">
          <Input />
        </Form.Item>
        <Form.Item name="destination" label={t("sonic_prospect.sales_handoff.rule_destination")} initialValue="Sales team">
          <Input />
        </Form.Item>
        <Form.Item name="leadCaptured" label={t("sonic_prospect.sales_handoff.rule_lead")} valuePropName="checked" initialValue>
          <Switch />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} block>
          {t("sonic_prospect.sales_handoff.create_rule")}
        </Button>
      </Form>
    </aside>
  );
}
